import { lazy } from 'react';

const CertifiedAvailablePageConfig = {
	settings: {
		layout: {
			config: {
				footer: {
					display: false
				},
			}
		}
		
	},
	routes: [
		{
			path: '/certificates/avaibles',
			component: lazy(() => import('./CertifiedAvailablePage'))
		}
	]
};

export default CertifiedAvailablePageConfig;